// @flow
export const SIDEBAR_TOUCHED = 'sidebarIsTouched'

export const ACTIVE_TAB_STORAGE_KEY = 'active_sidebar_tab'
